.footer {
    background-color: #3b354b;
    height: 15vh;
    display: flex;
    flex-direction: row;
    justify-content: end;
    padding: 2rem;
    margin-top: auto;
  }
  
  .footer h4 {
    color: white;
    font-size: 0.75rem;
    display: flex;
    flex-direction: row;
    align-content: center;
    font-weight: 300;
  }
  
  .footer h4 span {
    font-size: 1.25rem;
    padding-right: 0.5rem;
  }
  